import {
  createContext,
  Dispatch,
  SetStateAction,
  useState,
  ReactNode,
} from "react";

interface FileContextType {
  newFile: File | null;
  setNewFile: Dispatch<SetStateAction<File | null>>;
}

export const DataRepoFileContext = createContext<FileContextType | undefined>(
  undefined
);

interface FileProviderProps {
  children: ReactNode;
}

export const DataRepoFileProvider: React.FC<FileProviderProps> = ({
  children,
}) => {
  const [newFile, setNewFile] = useState<File | null>(null);

  return (
    <DataRepoFileContext.Provider value={{ newFile, setNewFile }}>
      {children}
    </DataRepoFileContext.Provider>
  );
};
